import React, { FC, useCallback, ChangeEvent } from 'react';
import { Box, Divider, RadioGroup, Typography } from '@mui/material';
import { RadioFormLabel, CoreRadio } from '../core-radio';
import { dividerStyles, operatorSelectStyles, operatorsRadioGroupStyles } from './core-conditional-select.styles';
import { OperatorProps } from './core-conditional-select.component';

export enum LogicalOperatorEnum {
	AND = 'AND',
	OR = 'OR'
}

export const LogicalOperatorsList = Object.values(LogicalOperatorEnum);

interface OperatorSelectProps extends OperatorProps {
	operator?: LogicalOperatorEnum;
	onChange?(operator: LogicalOperatorEnum): void;
}

export const LogicalOperatorSelect: FC<OperatorSelectProps> & { muiSkipListHighlight: true } = (props) => {
	const { operator = LogicalOperatorEnum.AND, onChange } = props;

	const t = (key: string) => key;

	const handleChange = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			onChange?.(event.target.value as LogicalOperatorEnum);
		},
		[onChange]
	);

	return (
		<Box sx={operatorSelectStyles}>
			<Box sx={operatorsRadioGroupStyles}>
				<Typography sx={{ mr: 2 }}>
					{'Logic'}
				</Typography>
				<RadioGroup row value={operator} onChange={handleChange}>
					<RadioFormLabel label={'And'} control={<CoreRadio />} value={LogicalOperatorEnum.AND} />
					<RadioFormLabel
						label={'Or'}
						control={<CoreRadio />}
						sx={{ mr: 0 }}
						value={LogicalOperatorEnum.OR}
					/>
				</RadioGroup>
			</Box>
			<Divider sx={dividerStyles} />
		</Box>
	);
};

LogicalOperatorSelect.muiSkipListHighlight = true;
